import { ReactNode } from 'react';
import { useLang } from 'hooks/lang';

import { loaders } from 'entities';

import { Column, Skeleton, Tag, TagProps, Tooltip } from 'components/Blocks';
import { UsersIcon } from 'components/Icons';

import { cn } from 'styles';

interface TeamTagProps extends Partial<TagProps> {
  team: string;
  icon?: ReactNode;

  action?: () => void;

  showLoading?: boolean;
}

export function TeamTag({ team, action, icon, showLoading = true, ...tagProps }: TeamTagProps) {
  const { t } = useLang();

  const { data, loading } = loaders.teams.find.use({
    params: { id: team },
  });

  if (showLoading && loading) return <Skeleton width={120} height="auto" className="min-h-4" />;

  if (!data) return null;

  return (
    <Tooltip
      content={
        <Column gap="0.5">
          {t('team-responsible')}

          {action && (
            <span className="text-center text-xs italic text-muted-foreground">
              {t('click-to-change')}
            </span>
          )}
        </Column>
      }
    >
      <button
        onClick={action}
        className={cn('inline-flex items-center outline-[0]', !action && 'cursor-default')}
      >
        <Tag
          color="foreground"
          type="outlined"
          round={false}
          name={
            <>
              {icon ?? <UsersIcon size={14} />}
              {data.name}
            </>
          }
          {...tagProps}
        />
      </button>
    </Tooltip>
  );
}
